/**
 * Created by neo on 10.01.2026
 * Motivation Screen - Shows available challenges, community posts, and points
 * Redesigned: Single page with section previews (no tabs)
 * Modernized: Each section loads independently with Suspense boundaries
 */
import * as React from 'react';
import { Suspense } from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { DailyGoalsSection } from './Sections/DailyGoalsSection';
import { ChallengesSection } from './Sections/ChallengesSection';
import { CommunitySection } from './Sections/CommunitySection';
import { SectionSkeleton } from './Components/SectionSkeleton';
import { Container } from 'reactstrap';
import { ServiceLifecycleCard } from '../../Components/ServiceLifecycleBoundary';
import { Theme } from '../../Theme/Theme';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const PageContent = styled(Container)`
  margin: 0 auto;
  padding: 48px 12px 64px;
  animation: ${fadeIn} 0.5s ease-out;

  @media (max-width: 768px) {
    padding: 32px 16px 48px;
  }
`;

const Page = styled.div`
  background: ${Theme.Colors.white};
`;

const SectionWrapper = styled.div`
  & + & {
    margin-top: 48px;
  }
`;

export const MotivationScreen: React.FC = observer(() => {
  return (
    <Page>
      <PageContent>
        <ServiceLifecycleCard inContent />
        <SectionWrapper>
          <Suspense fallback={<SectionSkeleton variant="grid" />}>
            <DailyGoalsSection />
          </Suspense>
        </SectionWrapper>

        <SectionWrapper>
          <Suspense fallback={<SectionSkeleton variant="cards" />}>
            <ChallengesSection />
          </Suspense>
        </SectionWrapper>

        <SectionWrapper>
          <Suspense fallback={<SectionSkeleton variant="cards" />}>
            <CommunitySection />
          </Suspense>
        </SectionWrapper>
      </PageContent>
    </Page>
  );
});
